import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { cn } from '@/lib/utils'

type BackLinkProps = {
    href: string
    children: ReactNode
    className?: string
}

export const BackLink: FC<BackLinkProps> = ({ href, children, className }): ReactNode => {
    return (
        <Link
            href={href}
            className={cn(
                'group inline-flex items-center gap-1.5 font-body text-[16px] leading-[1.4em] text-ink-soft transition-colors duration-300 hover:text-ink',
                className
            )}
        >
            <span
                aria-hidden='true'
                className='inline-block transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:-translate-x-1'
            >
                ‹
            </span>

            {children}
        </Link>
    )
}
